import { ApplicationRef } from '@angular/core';
import { fromEvent } from 'rxjs';

if ('scrollRestoration' in history) {
	history.scrollRestoration = 'manual';
}

const unloadObservable = fromEvent(globalThis, 'unload');

export function onAppModuleCreated(app: ApplicationRef) {
	const unloadSub = unloadObservable.subscribe(() => {
		unloadSub.unsubscribe();
		app.destroy();
	});
}
